module.exports = __webpack_public_path__ + "media/images/front/icon_db_200_as-73cc1aaa2da76241a9c997691f2b8fd6.png";